module.exports = __webpack_public_path__ + "img/pwa-installed-award.af6cf0a6.png";